import { ReactNode } from "react";
import { ActionIcon, Button, SpacingValue } from "@mantine/core";

export interface PaginationItemProps {
    content?: ReactNode;
    isActive?: boolean;
    isDisabled?: boolean;
    isEdge?: boolean;
    ml?: SpacingValue;
    mr?: SpacingValue;
    onClick?();
}

export const PaginationItem = ({ content, isActive, isDisabled, isEdge, ml, mr, onClick }: PaginationItemProps) => {
    if (isEdge) {
        return (
            <ActionIcon
                size="xl"
                radius="xl"
                color="dark"
                variant="filled"
                ml={ml}
                mr={mr}
                disabled={isDisabled}
                onClick={onClick}
            >
                {content}
            </ActionIcon>
        );
    }

    return (
        <Button
            size="md"
            radius="xl"
            color="dark"
            ml={ml}
            mr={mr}
            variant={
                typeof onClick === "function" ?
                    (isActive ? "filled" : "white") :
                    "transparent"
            }
            style={{
                paddingInline: 17,
                cursor: typeof onClick === "function" ?
                    "pointer" : "default",
            }}
            disabled={isDisabled}
            onClick={onClick}
        >
            {content}
        </Button>
    );
};
